import { VideoDetails } from '@news-mono/web-common'

/**
 * Gets the poster image for the video, this is the 16:9 crop if it's https
 */
export function getPosterImage(currentVideo: VideoDetails) {
    const crop16by9 = currentVideo.posterImage?.crops?.['16:9']
    if (crop16by9 && crop16by9.reference.indexOf('https') >= 0) {
        return crop16by9
    }

    const original = currentVideo.posterImage?.crops?.original
    if (original && original.reference.indexOf('https') >= 0) {
        return original
    }

    return undefined
}
